export default __webpack_public_path__ + "be49ce048568b08346252cd04723f932.svg";